<template>
  <div v-if="basket.deliveryType === 'self'" class="delivery-address-component">
    <span class="sub-title">Самовывоз:</span>
    <span class="address">
      {{ getFilialAddress }}
    </span>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'DeliveryPickup',

    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        filials: state => state.branches.branches,
      }),
      getFilialAddress () {
        return this.basket?.filial?.name
        /* for (let i = 0; i < this.filials.length; i++) {
          if (this.filials[i].id === this.basket.filialId) {
            return this.filials[i].city + ', ' + this.filials[i].address
          }
        }
        return '' */
      },
    },
  }
</script>

<style lang="less" scoped>
.delivery-address-component {
  border-radius: 10px;
  background-color: #fff3d6;
  padding: 0.64em 1.14em;
  margin-bottom: 1em;
  //display: flex;
  //align-items: flex-end;
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .sub-title {
    //display: block;
    font-size: 1em;
    line-height: 1.5;
    color: #5e5e5e;
    margin-right: 7px;
    font-weight: 300;
  }

  .address {
    /*font-size: 1.2em;
    line-height: 21px;*/
    font-size: 1em;
    //font-size: 14px;
    line-height: 1.23;
    .media-xl({
      //font-size: 15px;
    })
  }
}
</style>
